<template>
  <section id="footer">
    <v-footer dark padless>
      <v-card width="100%" flat dark tile color="primary" class="text-center">
        <v-card-text>
          <v-btn
            v-for="icon in icons"
            :key="icon.i"
            class="mx-4 white--text"
            icon
            :href="icon.link"
            target="_blank"
          >
            <v-icon large>{{ icon.icon }}</v-icon>
          </v-btn>
        </v-card-text>

        <!-- <v-card-text class="white--text pt-0">
          Phasellus feugiat arcu sapien, et iaculis ipsum elementum sit amet.
          Mauris cursus commodo interdum. Praesent ut risus eget metus luctus
          accumsan id ultrices nunc. Sed at orci sed massa consectetur dignissim
          a sit amet dui. Duis commodo vitae velit et faucibus. Morbi vehicula
          lacinia malesuada. Nulla placerat augue vel ipsum ultrices, cursus
          iaculis dui sollicitudin. Vestibulum eu ipsum vel diam elementum
          tempor vel ut orci. Orci varius natoque penatibus et magnis dis
          parturient montes, nascetur ridiculus mus.
        </v-card-text> -->

        <v-divider></v-divider>

        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>ARGECAM SRL</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </section>
</template>

<script>
export default {
  data: () => ({
    icons: [
      {
        icon: "mdi-facebook",
        link: "https://www.facebook.com/Argecam-SRL-279391785494145"
      },
      {
        icon: "mdi-instagram",
        link: "https://www.instagram.com/argecam.srl/"
      }
    ]
  })
};
</script>

<style scoped>
#footer {
  z-index: 0 !important;
}
</style>
